const toText = value => String(value ?? '').trim();

const hasWhitespace = value => /\s/.test(toText(value));

const looksLikeCompactCode = value => {
	const text = toText(value);

	return Boolean(text && !hasWhitespace(text));
};

const looksLikeDescription = value => {
	const text = toText(value);

	return Boolean(text && hasWhitespace(text));
};

export const shouldSwapItemCodeAndName = ({ code, name } = {}) =>
	looksLikeDescription(code) && looksLikeCompactCode(name);

export const normalizeItemIdentity = record => {
	if (!record) return record;

	const code = record.item_code ?? record.item;
	const name = record.item_name ?? record.name;

	if (!shouldSwapItemCodeAndName({ code, name })) return record;

	return {
		...record,
		...(Object.prototype.hasOwnProperty.call(record, 'item_code')
			? { item_code: name }
			: {}),
		...(Object.prototype.hasOwnProperty.call(record, 'item_name')
			? { item_name: code }
			: {}),
		...(Object.prototype.hasOwnProperty.call(record, 'item')
			? { item: name }
			: {}),
		...(Object.prototype.hasOwnProperty.call(record, 'name')
			? { name: code }
			: {}),
	};
};

export const normalizeItemIdentities = records =>
	Array.isArray(records) ? records.map(normalizeItemIdentity) : records;
